import { useMutation, MutateOptions } from "@tanstack/react-query";
import { useNotification } from "@/context/NotificationProvider";

type TParamsBase = {
  options?: {
    msgSucesso?: string;
    msgErro?: string;
    msgErroFallback?: string;
  };
};

// Se TParams for void, o parâmetro fica opcional; senão, obrigatório.
// O segundo parâmetro replica o `options` padrão do react-query (onSuccess/onError/onSettled).
type MutateFn<TParams, TData, TReturn> = TParams extends void
  ? (params?: TParamsBase, options?: MutateOptions<TData, Error, TParamsBase>) => TReturn
  : (params: TParams & TParamsBase, options?: MutateOptions<TData, Error, TParams & TParamsBase>) => TReturn;

export const useHookMutation = <TData = unknown, TParams = void>(func: (params: unknown) => Promise<TData>) => {
  const { setNotification } = useNotification();

  const mutation = useMutation<TData, Error, TParams & TParamsBase>({
    mutationFn: async (params) => {
      return func(params as Record<string, unknown>);
    },
    onSuccess: (_, vars) => {
      if (vars?.options?.msgSucesso) {
        setNotification({ type: "success", message: vars.options.msgSucesso });
      }
    }
    // erro não tratado aqui — mutationCache.onError global (queryClient.ts) já resolve. Duplicaria notif.
  });

  return {
    ...mutation,
    mutate: mutation.mutate as MutateFn<TParams, TData, void>,
    mutateAsync: mutation.mutateAsync as MutateFn<TParams, TData, Promise<TData>>
  };
};
